import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroFluxoCaixaPage } from '@/features/relatorio/page/financeiro/fluxo-caixa/RelatorioFinanceiroFluxoCaixaPage';

export const Route = createFileRoute('/a/relatorio/financeiro/fluxo-caixa')({
    component: RelatorioFinanceiroFluxoCaixaPage,
});
